import React, {useContext} from "react";
import { ObjectLiteral } from "../../../interfacesProps/ObjectLiteralProps";
import { Spacing, Colors, FontSize, Font } from "../../../theme/Theme";
import { RenderTextWithTitle } from "../../../components/TextWithHeader";
import { ColumnStyle } from "../../../theme/ComponentTheme";
import formatService from "../../../util/FormattingService";
import { RBMap } from "../../../components/RBMap";
import { LocationStats } from "../../../components/LocationStats";
import { FormControlLabel, Checkbox, Typography } from "@material-ui/core";
import { RBContext } from "../../../components/RBContext";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

interface PharmacyInformationProps {
  shiftData: ObjectLiteral;
  pharmacy:ObjectLiteral;
  owner:boolean;
  showPartialInfo:boolean;
  account:ObjectLiteral;
  page:string;
  applied?:Boolean;
}

const NoPhaymacyInformation = () => {
  return (
    <div>
      <div className={"section-header-text"}>Pharmacy Information</div>
      <div>
        <div>
          You&apos;ll be able to div the pharmacy information after you are {}
          confirmed for the shift.
        </div>
      </div>
      <div
        style={{
          height: 1,
          backgroundColor: Colors.defaultGrey,
          marginTop: Spacing.medium,
          marginBottom: Spacing.medium,
        }}
      />
    </div>
  );
};

export const PharmacyInformation: React.FC<PharmacyInformationProps> = ({
  ...props
}) => {
  const { primaryColor,secondaryColor } = useContext(RBContext);
  const { shiftData ,page,account,showPartialInfo, applied} = props;
  const workerNetworkId = account.networks[0].id;
  const pharmacy = shiftData.pharmacy;
  const owner = shiftData.creator ? shiftData.creator.owner : false;

  console.log("Page:", page);
  console.log("Applied:", applied);
  console.log("Pharmacy About:", pharmacy.about);

  const { address } = pharmacy;
  const coordinate = {
    latitude: address.coordinate.coordinates[1],
    longitude: address.coordinate.coordinates[0],
  };
  const addressFormat = address.apartmentSuiteNumber
    ? address.apartmentSuiteNumber +
      " - " +
      address.streetAddress +
      "\n" +
      address.city +
      " " +
      address.province +
      "\n" +
      address.postalCode
    : address.streetAddress +
      "\n" +
      address.city +
      " " +
      address.province +
      "\n" +
      address.postalCode;

  const addressFormatWithOutStreet = address.city +
      ' ' +
      address.province +
      '\n' +
      address.postalCode;
  const blurAddress = address.apartmentSuiteNumber
      ? address.apartmentSuiteNumber +
        ' - ' +
        address.streetAddress +
        '\n'
      : address.streetAddress +
        '\n';

  if (!shiftData.pharmacy) {
    return <>{NoPhaymacyInformation()}</>;
  }
  if (showPartialInfo) {
    return (
      <div>
        <div className={"section-header-text"} style={{marginBottom:10, fontSize:Font.largest}}>Pharmacy Information</div>
        <div style={ColumnStyle}>
          <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            overflowWrap: "anywhere",
            alignItems: "flex-start",
            alignContent: "flex-start",
            justifyContent: "flex-start",
            width: 100
          }}
        >
          <div
            style={{
              display: "flex",
              flex: 1,
              overflowWrap: "anywhere",
              fontWeight: "bold",
              fontSize: FontSize.large,
            }}
          >
            Pharmacy
          </div>

          {page == 'applyJob' && applied == false  ? 
          <div
          style={{
           filter:'blur(3px)'
          }}
        >
          {pharmacy.name}
        </div>
         :
         <div
         style={{
           display: "flex",
           flex: 1,
           whiteSpace: "pre-wrap",
           overflowWrap: "anywhere",
           fontSize: FontSize.large,
         }}
       >
         {pharmacy.name}
       </div>
           
}
        </div>
          {page && page == "applyShift" ?
          (account.networks[0].isTrustNetwork === true  &&
            account.pharmacist.approval?.rbVerified === true &&
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                overflowWrap: "anywhere",
                alignItems: "center",
                alignContent: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  overflowWrap: "anywhere",
                  fontSize: FontSize.default,

                }}
              >
                {pharmacy?.networkId === workerNetworkId ? 'In-Network' : 'Out-of-Network'}
              </div>

              <div
                style={{
                  display: "flex",
                  flex: 1,
                  whiteSpace: "pre-wrap",
                  overflowWrap: "anywhere",
                  fontWeight: "bold",
                  fontSize: FontSize.large,
                }}
              >
              <img
                src={
                  pharmacy?.networkId === workerNetworkId ?
                    require('../../../img/50x50-01.png')
                      : require('../../../img/100x100-02-01.png')
                }

                style={{
                  height: 50,

                }}
              />
              </div>
            </div>) : null
          }
      </div>
      <div style={ColumnStyle}>
        {page == 'applyJob' && applied == false  ? 
        <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          overflowWrap: "anywhere",
          alignItems: "flex-start",
          alignContent: "flex-start",
          justifyContent: "flex-start",
          width:100
        }}
      >
        <div
          style={{
            display: "flex",
            flex: 1,
            overflowWrap: "anywhere",
            color: Colors.darkGrey,
            fontSize: FontSize.default,
          }}
        >
          Pharmacy Address
        </div>
  
        <div
          style={{
            display: "flex",
            flex: 1,
            whiteSpace: "pre-wrap",
            overflowWrap: "anywhere",
            fontSize: FontSize.large,
            filter:'blur(3px)'
          }}
        >
          {blurAddress}
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            whiteSpace: "pre-wrap",
            overflowWrap: "anywhere",
            fontWeight: "bold",
            fontSize: FontSize.large,
          }}
        >
          {addressFormatWithOutStreet}
        </div>
      </div>
        
        : 
        RenderTextWithTitle("Pharmacy Address",  addressFormat)}
        {page == 'applyJob' && applied == false  ?
        <RBMap
          style={{
            display: "flex",
            flex: 1,
            height: 150,
            marginTop: Spacing.medium,
          }}
          lat={coordinate.latitude}
          lng={coordinate.longitude}
          markerFlag={true}
        />:
        <RBMap
        style={{
          display: "flex",
          flex: 1,
          height: 150,
          marginTop: Spacing.medium,
        }}
        lat={coordinate.latitude}
        lng={coordinate.longitude}
      />}
      </div>


      {/* About Us Section */}
      {pharmacy.about && (page === "applyShift") && (
        <div style={{ width: '100%', ...ColumnStyle, marginTop: Spacing.medium }}>
          {RenderTextWithTitle("About Us (Shift specific information for the Pharmacy)", pharmacy.about)}
        </div>
      )}


      
      {page && (page == "applyShift" || page == "applyJob") &&
      account.networks[0].isAcceptedEmploymentTypesEnabled=== true && Array.isArray(pharmacy?.acceptedEmploymentTypes) && pharmacy?.acceptedEmploymentTypes.length > 0 &&
        <>
         <hr style={{ border: 'none', borderTop: `1px solid ${Colors.mediumGrey}`, margin: `${Spacing.small} 0` }} />
          <div style={{ marginTop: Spacing.large }}>
            <Typography style={{ fontWeight: 'bold' }}>Payment Methods</Typography>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
              {(pharmacy.acceptedEmploymentTypes || []).map((method: string) => (
                <FormControlLabel
                  key={method}
                  control={
                    <Checkbox
                      checked={true}
                      icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                      checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                    />
                  }
                  label={method}
                />
              ))}
            </div>
          </div>
        </>
        }
        
        {page && page == "applyShift" && 
        <>

        <div
          style={{
            height: 1,
            backgroundColor: Colors.defaultGrey,
            marginTop: Spacing.medium,
            marginBottom: Spacing.medium,
          }}
        />
        <LocationStats account={pharmacy} />
        </>}
      </div>
    );
  }

  return (
    <div>
      <div
        className="section-header-text"
        style={{
          paddingBottom: Spacing.small,
          marginBottom: Spacing.smallest,
        }}
      >
        Pharmacy Information
      </div>
      <div style={ColumnStyle}>
        {RenderTextWithTitle("Pharmacy", pharmacy.name)}
        {RenderTextWithTitle(
          "Pharmacy Phone",
          formatService.formatPhoneNumber(pharmacy.phone)
        )}
      </div>
      <div style={ColumnStyle}>
        {RenderTextWithTitle("Pharmacy Address", addressFormat)}
        <RBMap
          style={{
            display: "flex",
            flex: 1,
            height: 150,
            marginTop: Spacing.medium,
          }}
          lat={coordinate.latitude}
          lng={coordinate.longitude}
        />
      </div>
      <div style={ColumnStyle}>
        {RenderTextWithTitle(
          "Pharmacy Manager",
          pharmacy.contactFirstName + " " + pharmacy.contactLastName
        )}
        {RenderTextWithTitle(
          "Manager Phone",
          formatService.formatPhoneNumber(pharmacy.contactPhone)
        )}
      </div>
      <div style={ColumnStyle}>
        {RenderTextWithTitle(
          "Primary Contact",
          owner.firstName + " " + owner.lastName
        )}
        {RenderTextWithTitle(
          "Primary Contact Phone",
          formatService.formatPhoneNumber(owner.phone)
        )}
      </div>
      <div
        style={{
          height: 1,
          backgroundColor: Colors.defaultGrey,
          marginTop: Spacing.medium,
          marginBottom: Spacing.medium,
        }}
      />
    </div>
  );
};
